import { render, staticRenderFns } from "./PlayerGiftSent.vue?vue&type=template&id=6fc8c121&scoped=true&"
import script from "./PlayerGiftSent.vue?vue&type=script&lang=js&"
export * from "./PlayerGiftSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8c121",
  null
  
)

export default component.exports